// import InPokerImg from '../assets/images/indian casino/poker.jpg';
import Luckey_7A from '../assets/images/indian casino/luckey_7A.png';
import Luckey_7B from '../assets/images/indian casino/luckey_7B.jpg';

// import In32CardsImg from '../assets/images/indian casino/32 cards.jpg';
import InAndarBaharImg from '../assets/images/indian casino/andar_bahar.jpg';
// import InTPImg from '../assets/images/indian casino/teenpatti.jpg';
import InTP20Img from '../assets/images/indian casino/teenpattit20.jpg';

export const INDIAN_CASINO_GAMES = [
  {
    id: 'lucky7',
    name: 'Lucky 7A',
    streamURL: 'https://ic.hypexone.com/?params=8011,LUCKY7',
    image: Luckey_7A,
    gameCode: 56767
  },
  {
    id: 'lucky7b',
    name: 'Lucky 7B',
    streamURL: 'https://ic.hypexone.com/?params=8017,LUCKY7B',
    image: Luckey_7B,
    gameCode: 87564
  },
  {
    id: 'andarbahar',
    name: 'Andar Bahar',
    streamURL: 'https://ic.hypexone.com/?params=8010,AB',
    image: InAndarBaharImg,
    gameCode: 67564
  },
  {
    id: 'tp2020',
    name: '20-20 Teenpatti',
    streamURL: 'https://ic.hypexone.com/?params=8015,TP2020',
    image: InTP20Img,
    gameCode: 98789
  },
];

export const INDIAN_CASINO_GAMES_MAP = {
  lucky7b: 'Lucky_7_B',
  lucky7: 'Lucky_7_A',
  andarbahar: 'ANDAR_BAHAR',
  tp2020: 'TENNPATTI_2020',
  // dragontiger: 'DRAGON_TIGER_2020',
  // dragontigerlion: 'DRAGON_TIGER_LION',
  // aaa: 'BOLLYWOOD_CASINO_AAA',
  // race2020: 'RACE_2020',
  // '32cards': 'CARD_32',
  // '3cardj': 'CARD_JUDGMENT_3',
  // andarbahar: 'ANDAR_BAHAR',
};
